import API from "@/api";
import { INursery } from "@/types/data";
import { useState } from "react";

const fetchUserNurseries = async (nurseries: Array<INursery>) => {
  return Promise.all(nurseries.map((nursery) => {
    return Promise.all([
      API.getNursery(`${nursery.id}`),
      API.getNurseryStats(`${nursery.id}`),
      API.getObservationDates(`${nursery.id}`),
      API.getTanks(`${nursery.id}`)
        .then((tanks) => Promise.all(
          tanks.results.map((tank) => fetchTank(`${nursery.id}`, `${tank.id}`))
        ))
    ]);
  }));
};

const fetchTank = async (nurseryId: string, tankId: string) => {
  return Promise.all([
    API.getTank(nurseryId, tankId),
    API.getTankStats(nurseryId, tankId),
    API.getObservationDates(`${nurseryId}`, new URLSearchParams({ "rack__tank": tankId! })),
    API.getRacks(nurseryId, tankId)
      .then((racks) => Promise.all(
        racks.results.map((rack) => 
          Promise.all([
            API.getRack(nurseryId, `${rack.id}`),
            API.getObservationDates(`${nurseryId}`, new URLSearchParams({ "rack": `${rack.id}` })),
            API.getRackObservations(nurseryId, `${rack.id}`),
          ])
        )
      ))
  ]);
};

const useCacheData = () => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const [error, setError] = useState<Error>();

  const fetchUserData = () => {
    setIsPending(true);
    setError(undefined);
    return new Promise<void>((resolve, reject) => {
      API.getNurseries()
        .then((nurseries) => fetchUserNurseries(nurseries.results))
        .then(() => localStorage.setItem("cache_date", new Date().toJSON()))
        .then(() => resolve())
        .catch(() => {
          setError(new Error("Error downloading nursery data."));
          reject();
        })
        .finally(() => setIsPending(false));
    });
  };

  return {
    fetchUserData,
    isPending,
    error
  };
};

export default useCacheData;
